// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__eGGMv","header":"ReportDetails_header__1j5f5","title":"ReportDetails_title__wMYMD","left":"ReportDetails_left__1QqSJ"};